exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-e5880e3a] {\n  font-weight: normal;\n  margin: 12px 0px 0px;\n}\n.no-selection[data-v-e5880e3a] {\n  pointer-events: none; /* Deshabilitar la interacción con la fila no seleccionable */\n  opacity: 0.5; /* Puedes cambiar el estilo para indicar visualmente que no está seleccionable */\n}\n", ""]);

// exports
